import React, { useEffect, useRef } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

export default function GalaxyHeaderBackground() {
  // Animation for stars
  const twinkleAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(twinkleAnim, {
          toValue: 1,
          duration: 2000,
          useNativeDriver: false, // backgroundColor doesn't support native driver sometimes, but opacity does
        }),
        Animated.timing(twinkleAnim, {
          toValue: 0,
          duration: 2000,
          useNativeDriver: false,
        }),
      ]),
    ).start();
  }, []);

  const stars = Array.from({ length: 25 }).map((_, i) => ({
    id: i,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2 + 1,
    opacity: Math.random() * 0.5 + 0.3,
  }));

  return (
    <View style={StyleSheet.absoluteFill}>
      <LinearGradient
        colors={['#050A30', '#0b1654', '#1e1b4b']} // Galaxy Theme
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }}
        style={StyleSheet.absoluteFill}
      />

      {stars.map((s) => (
        <Animated.View
          key={s.id}
          style={{
            position: 'absolute',
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            borderRadius: s.size / 2,
            backgroundColor: '#ffffff',
            opacity: twinkleAnim.interpolate({
              inputRange: [0, 0.5, 1],
              outputRange: [s.opacity, s.opacity * 0.4, s.opacity],
            }),
          }}
        />
      ))}

      {/* Subtle overlay */}
      <View style={[StyleSheet.absoluteFill, { backgroundColor: 'rgba(79, 70, 229, 0.05)' }]} />
    </View>
  );
}
